/**
 * Asynchronously loads the component for AddQuestion
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
